import "../layout.css";
import MeasureList from "../components/measure-list.tsx";
import StatisticsList from "../components/statistics-list.tsx";
import PlusMenu from "../components/plus.tsx";
import House from "../components/house.tsx";
import { clsx } from "../functions.ts";
import { useStore } from "../state/state.ts";
import View, { H, P, ViewCopy, ViewCopyLong } from "../components/view.tsx";
import ModalHeizung from "../modals/modal_heizung.tsx";
import ModalKeller from "../modals/modal_keller.tsx";
import ModalFenster from "../modals/modal_fenster.tsx";
import ModalSolarthermie from "../modals/modal_solarthermie.tsx";
import ModalLueftung from "../modals/modal_lueftung.tsx";
import ModalPhotovoltaik from "../modals/modal_photovoltaik.tsx";
import ModalFassade from "../modals/modal_fassade.tsx";
import ModalDach from "../modals/modal_dach.tsx";
import {ReactNode, useEffect} from "react";

export default function ViewCurrentState() {
  const selected_menu_item = useStore((state) => state.selected_menu_item);
  const keep_menu_open = useStore((state) => state.keep_menu_open);

  const dialogs : Record<string, ReactNode> = {
    heizung: <ModalHeizung />,
    dach: <ModalDach />,
    keller: <ModalKeller />,
    fenster: <ModalFenster />,
    fassade: <ModalFassade />,
    solarthermie: <ModalSolarthermie />,
    photovoltaik: <ModalPhotovoltaik />,
    lueftung: <ModalLueftung />,
  };

  return <View>
          <div className="layout">
            <div className="layout__col layout__col-left">
              <ViewCopy>
                <H>Wurden in der Vergangenheit bereits Sanierungen durchgeführt?</H>
                <P>Die betroffenen Bauteile im 3D-Haus anklicken und deren jetzigen Sanierungszustand auswählen. Alternativ ‚Detail hinzufügen‘ nutzen.</P>
              </ViewCopy>
              <PlusMenu label={"Detail hinzufügen"} dialogs={dialogs}/>
              <MeasureList />
              
            </div>
            <div className="layout__col layout__col-center">
              <StatisticsList/>
              <House dialogs={dialogs} />
            </div>
        </div>
    </View>
}
